module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by Deborah M. Dyer")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgments"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Mountdesert"
    }
  }, [_vm._v("Mount Desert")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('a', {
    attrs: {
      "href": "#/Maps"
    }
  }, [_vm._v("Map of the Bar Harbor Historic Buildings and Monuments Trail")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("1. The Bar Harbor Wharf (Ells Plaque, Bar Harbor Municipal Pier, One Town Pier)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Queen and the Princess of Saloons: Lizzie Ford and Ada Bearse (Galyn’s Restaurant, 17 Main Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Return of Eden’s Prodigal Sons: Herb Redding and Smylie Grant Ells (Sherman’s Book Store, 56 Main Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Bar Harbor Village Improvement Association and the One-Horse Town (Morrison Building, 62 Main Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Bradley Block (First National Bank, 102 Main Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Bee’s Store and Miss Shaw (Bar Harbor Hemporium, 116 Main Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Will of William M. Roberts (Roberts Monument, Bar Harbor Village Green)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Car and the Village Green (Village Green Bandstand, Village Green, Main and Mount Desert Streets)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Coaster’s Checkbook/Ash Graves (Mount Desert Street Cemetery, 41 Mount Desert Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Church Lady: Elizabeth Higgins (St. Saviour’s Episcopal Church and Rectory, 41 Mount Desert Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Misses Shannon (Ledgelawn Inn, 66 Mount Desert Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Oldest Cottage on Mount Desert Street (Stone Throw Cottage Inn and Mira Monte Inn, 67 and 69 Mount Desert Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The Lost Girl of Holland Avenue (Jane Parker House, 48 Holland Avenue)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The Missing Block (Walter Bird House, 10 Holland Avenue)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Music Hall, the Casino and the Way Bak Ball (Alonzo Ash House, 6 Summer Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. World War I and the Spanish Influenza (George Edwin Kirk American Legion Post 0025, 70 Cottage Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Pearl Otto Wescott and the Star Theatre (Star Theatre Building, 44 Cottage Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Rags to Riches: How Peanut Row Became the Harborside Hotel (Whale Watch Building/Clark Coal Company Building, 55 West Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The West End Hotel and the Bar Harbor Club (Bar Harbor Club, 111 West Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Dr. John B. Ells and the OBE (La Rochelle/Bar Harbor Historical Society, 127 West Street)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. The Corner of Eden and West Streets (DeGregoire Green and Plaque, West and Eden Streets Corner)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The Coughs and the Atlantic Oakes (Sonny Cough Plaque by the Atlantic Eyrie Lodge, 6 Norman Road)")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3"
  }, [_c('span', {
    attrs: {
      "href": "#/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0